"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
var date_modifier_1 = require("../../model/util/date-modifier");
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('generator-collections.ts', shared_1.Styles.rainbowLeaf);
/******************************************** HELPERS *********************************************/
/**
 * GeneratorCollection factory: build GeneratorCollection object (from REST API
 * data or data in generatorCollection key of schedules.json)
 */
var buildGeneratorCollection = function (generatorCollectionData) {
    log.verbose('generatorCollectionData:', generatorCollectionData);
    return new javelin_exports_1.GeneratorCollection(generatorCollectionData.collectionId, generatorCollectionData.scheduleId, kotlin_map_factory_1.dirtyKotlinMap(generatorCollectionData.names), kotlin_map_factory_1.dirtyKotlinMap(generatorCollectionData.descriptions), generatorCollectionData.min
        ? new date_modifier_1.DateModifier(generatorCollectionData.min.years, generatorCollectionData.min.months, generatorCollectionData.min.weeks, generatorCollectionData.min.days)
        : null, generatorCollectionData.max
        ? new date_modifier_1.DateModifier(generatorCollectionData.max.years, generatorCollectionData.max.months, generatorCollectionData.max.weeks, generatorCollectionData.max.days)
        : null, generatorCollectionData.active, generatorCollectionData.canAddDoses, kotlin_map_factory_1.dirtyKotlinMap(generatorCollectionData.childIndexes), kotlin_map_factory_1.dirtyKotlinMap(generatorCollectionData.adultIndexes));
};
/****************************************** DATA EXPORT *******************************************/
// Memoized array of GeneratorCollectionInstance objects built from raw content data
var _generatorCollections;
/**
 * Export array of GeneratorCollection (GeneratorCollectionInstance) objects
 * Build collection on 1st run, then memoize (the content data is immutable)
 */
exports.generatorCollections = function (rawContentData) {
    _generatorCollections =
        _generatorCollections || rawContentData.generatorCollections.map(buildGeneratorCollection);
    log.verbose("generatorCollections:", util_1.inspect(_generatorCollections, false, 10, true));
    return _generatorCollections;
};
//# sourceMappingURL=generator-collections.js.map